































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import {
  BlueprintFieldsTypes,
  ProvisionFieldTypes
} from "@/data/enums/provisioning";

// Types
import {
  IBlueprintField,
  IProvisionProductFieldValue
} from "@/models/provisioning";

@Component
export default class ConfigureFieldRow extends Vue {
  @Prop({ required: true })
  public field!: IBlueprintField;

  @Prop({ required: true })
  public fieldValues!: IProvisionProductFieldValue[];

  @Prop({ default: "" })
  public fieldError!: string;

  @Prop({ default: ProvisionFieldTypes.PRODUCT_FIELD })
  public type!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  public getFieldValues() {
    return (
      this.$_.uniq(
        this.$_.filter(
          this.$_.map(
            this.fieldValues,
            (productFieldValue: IProvisionProductFieldValue) => {
              const fieldValue = this.$_.get(
                this.$_.find(
                  productFieldValue[
                    this.type === ProvisionFieldTypes.PRODUCT_FIELD
                      ? "provision_field_values"
                      : "provision_configuration_attribute_values"
                  ],
                  [
                    this.type === ProvisionFieldTypes.PRODUCT_FIELD
                      ? "blueprint_field_id"
                      : "attribute_id",
                    this.field.id
                  ]
                ),
                "value",
                null
              );

              if (fieldValue === null) {
                return fieldValue;
              }

              if (
                this.isSelect(this.field.field_type) ||
                this.isRadio(this.field.field_type)
              ) {
                return this.$_.get(
                  this.$_.find(this.$_.get(this.field, "options"), [
                    "value",
                    fieldValue
                  ]),
                  "label"
                );
              }

              return typeof fieldValue === "string" && 40 < fieldValue.length
                ? `${fieldValue.substr(0, fieldValue.lastIndexOf(" ", 40))}...`
                : fieldValue;
            }
          ),
          usedValue => usedValue !== null
        )
      ).join(" | ") || "-"
    );
  }

  public isSelect(fieldType: string) {
    return fieldType === BlueprintFieldsTypes.SELECT;
  }

  public isRadio(fieldType: string) {
    return fieldType === BlueprintFieldsTypes.INPUT_RADIO;
  }

  public configureField() {
    if (this.isDisabled) return;

    this.$emit("configureField", this.field);
  }
}
